<template>
  <div class="app mx-4">
    <header class="">
      <h1 class="text-4xl text-center font-bold">Playground Finder</h1>
    </header>
    <div class="flex flex-col w-full border-opacity-50">
      <div class="grid card bg-base-300 rounded-box border-gray-300 border-1 overflow-x-scroll">
        <div class="filters rounded bg-white text-black text-left">
          <LocationSearch @change-location="changeLocation" />
          <PlaygroundFilters :currentCoordinates="Coordinates" @filter="filterPlaygrounds" @distance-changed="handleDistanceChange" />
        </div>
      </div>
      <div class="divider"></div>
      <div class="grid card bg-base-100 rounded-box">
        <div class="grid grid-cols-1 md:grid-cols-4  md:gap-4 rounded">
          <div class="md:col-span-1">
            <PlaygroundList :Playgrounds="Playgrounds" :selectedPlayground="selectedPlayground" @playground-selected="centerMapOnPlayground" />
          </div>
          <div class="mt-6 md:mt-0 md:col-span-3">
            <PlaygroundMap @recentered="recenterMap" @playground-selected="selectPlaygroundFromMap" :Playgrounds="Playgrounds" :Coordinates="Coordinates" :selectedPlayground="selectedPlayground" :mapZoom="mapZoom" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocationSearch from "./components/LocationSearch.vue";
import PlaygroundMap from './components/PlaygroundMap.vue'
import PlaygroundList from "./components/PlaygroundList.vue";
import PlaygroundFilters from "./components/PlaygroundFilters.vue";
import PlaygroundsData from './playgrounds-advanced.json';
const startingCoordinates = [38.94, -94.66];

export default {
  name: 'App',
  components: {
    LocationSearch: LocationSearch,
    PlaygroundMap: PlaygroundMap,
    PlaygroundList: PlaygroundList,
    PlaygroundFilters: PlaygroundFilters
  },
  data() {
    return {
      Playgrounds: PlaygroundsData,
      Coordinates: startingCoordinates,
      selectedPlayground: null,
      mapZoom: 10
    }
  },
  methods: {
    filterPlaygrounds(filters) {
      let playgrounds = PlaygroundsData;

      // Apply feature filters
      if (filters.features && filters.features.length > 0) {
        filters.features.forEach((val) => {
          playgrounds = playgrounds.filter(playground => playground.details[val]);
        });
      }

      // Apply distance filter
      if (filters.distance && this.Coordinates) {
        playgrounds = playgrounds.filter(playground => {
          const distance = this.calculateDistance(
            this.Coordinates[0],
            this.Coordinates[1],
            playground.location.coordinates[0],
            playground.location.coordinates[1]
          );
          return distance <= filters.distance;
        });
      }

      this.Playgrounds = playgrounds;
    },
    changeLocation(location) {
      console.log('Change location called...');
      console.log(location);

      // Get the coordinates then push the new center to the map.
      let coords = [location.latitude, location.longitude];
      this.Coordinates = coords;
    },
    recenterMap(coords) {
      if (this.Coordinates !== coords) {
        this.Coordinates = coords;
      }
    },
    centerMapOnPlayground(playground) {
      // First center on the location
      this.Coordinates = playground.location.coordinates;
      this.selectedPlayground = playground;
      
      // Then zoom in after centering completes
      this.$nextTick(() => {
        setTimeout(() => {
          this.mapZoom = 15;
        }, 150);
      });
    },
    selectPlaygroundFromMap(playground) {
      this.selectedPlayground = playground;
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 3959; // Radius of Earth in miles
      const dLat = this.toRad(lat2 - lat1);
      const dLon = this.toRad(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    toRad(deg) {
      return deg * (Math.PI / 180);
    },
    getZoomForDistance(distance) {
      // Map distance ranges to appropriate zoom levels
      const zoomMap = {
        5: 13,    // 5 miles - close zoom
        25: 10,   // 25 miles - medium zoom
        50: 9,    // 50 miles - wider zoom
        100: 8    // 100 miles - very wide zoom
      };
      return zoomMap[distance] || 10; // default zoom
    },
    handleDistanceChange(distance) {
      if (distance) {
        this.mapZoom = this.getZoomForDistance(distance);
      } else {
        this.mapZoom = 10; // default zoom when no distance filter
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
